module.exports = [{"type":"title","text":"2024-09-11"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續幣本位：查詢K線接口，增加說明只允許查詢最近30天的數據。"},{"type":"html","text":"新增：代理API"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-09-11.json
// module id = EMrv
// module chunks = 3